export const skills = [
  [
    {
      label: "React",
      progress: 70,
    },
    {
      label: "React Native",
      progress: 70,
    },
  ],
  [
    {
      label: "Javascript",
      progress: 70,
    },

    {
      label: "TypeScript",
      progress: 60,
    },
  ],
  [
    {
      label: "Redux",
      progress: 35,
    },
    {
      label: "Firebase",
      progress: 35,
    },
  ],
  [
    {
      label: "HTML/CSS",
      progress: 90,
    },
    {
      label: "Node",
      progress: 45,
    },
  ],
  [
    {
      label: "Gatsby",
      progress: 50,
    },
    {
      label: "Shopify",
      progress: 35,
    },
  ],
  [
    {
      label: "Netlify CMS",
      progress: 80,
    },
    {
      label: "Web Design",
      progress: 60,
    },
  ],
];
